export type GridLine = { leftPx: number; key: string; label: string };

export function GridLayer({ lines }: { lines: GridLine[] }) {
  return (
    <>
      {lines.map((l) => (
        <div key={l.key}>
          {/*
            Dynamic-from-JS: leftPx is computed from the live axis-metrics
            (container scrollLeft + timeline TH bounding rect). Keep inline.
          */}
          <div className="tl-gridline" style={{ left: l.leftPx }} />
          <div className="tl-gridlabel" style={{ left: l.leftPx }}>
            {l.label}
          </div>
        </div>
      ))}
    </>
  );
}
